"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _CardSection = _interopRequireDefault(require("./CardSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = _styledComponents.default.div.withConfig({
  displayName: "Card",
  componentId: "sc-2y05wn-0"
})(["background:", ";border:", ";border-radius:4px;box-shadow:0 2px 4px 1px ", ";padding:", ";margin:0 0 ", ";& > *:last-child{margin-bottom:0;}", " ", " ", ":last-child{border:none;}"], (0, _helpers.color)('white'), function (_ref) {
  var theme = _ref.theme,
      cardStyle = _ref.cardStyle,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "1px solid ".concat(cardStyle ? (0, _helpers.statusToColor)(cardStyle) : (0, _helpers.color)('black60')({
    theme: theme
  })) : _ref$border;
  return border;
}, (0, _helpers.colorToAlpha)('black', 0.1), function (_ref2) {
  var _ref2$spacing = _ref2.spacing,
      spacing = _ref2$spacing === void 0 ? 'medium' : _ref2$spacing;
  return (0, _helpers.getSpacing)(spacing);
}, (0, _helpers.getSpacing)('medium'), function (_ref3) {
  var elevation = _ref3.elevation;
  return elevation === 'flat' && 'box-shadow: none;';
}, function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation === 'raised' && "box-shadow: 0 4px 12px 1px ".concat((0, _helpers.colorToAlpha)('black', 0.1)({
    theme: theme
  }), ";");
}, _CardSection.default);

var _default = Card;
exports.default = _default;